import React from "react";
import moment from "moment-timezone";

const formatVerifierName = (name) => {
  if (!name) return "Unknown";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];
  const initial = parts[0].charAt(0).toUpperCase();
  const lastName = parts[parts.length - 1];
  return `${initial}. ${lastName}`;
};

const buildCopy = (verifiedBy, verifiedAt) => {
  const who = formatVerifierName(verifiedBy?.name);
  if (!verifiedAt) return `Verified by ${who}`;
  const when = moment(verifiedAt).tz("America/New_York");
  return `Verified by ${who} at ${when.format("h:mm A")} ET on ${when.format(
    "MMMM Do, YYYY",
  )}`;
};

const VerifiedByBlock = ({ trip, canUnverify, onUnverify, className = "" }) => {
  if (!trip?.verified) return null;

  return (
    <div className={`tv-verified-by-wrap ${className}`.trim()}>
      <div className="tv-verified-by">
        <span className="material-icons">check_circle</span>
        <span>{buildCopy(trip.verifiedBy, trip.verifiedAt)}</span>
      </div>

      {canUnverify && (
        <button
          type="button"
          className="base-button btn-danger tv-unverify-button"
          onClick={onUnverify}
        >
          Unverify Trip
        </button>
      )}
    </div>
  );
};

export default VerifiedByBlock;
